/**
 * Welcome card component
 *
 * @unstable
 */

import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { SurveyStore } from '@player/shared/services/survey-store.service';
import { LanguageManager } from '@player/shared/services/language-manager.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { LanguageSelect } from '@player/+survey/drawer/language-select/language-select.component';
import { TranslateText } from '@player/shared/pipes/translate-text.pipe';
import { BasicModule } from '@shared/modules/basic.module';
import { SafeHtml } from '@shared/pipes/safe-html.pipe';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'welcome-card',
  templateUrl: './welcome-card.component.html',
  styleUrls: ['./welcome-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgClass, MatIcon, LanguageSelect, TranslateText, BasicModule, SafeHtml],
})
export class WelcomeCard {
  readonly ss = inject(SurveyStore);
  readonly lm = inject(LanguageManager);

  @Input() isAnonymous?: boolean;
  @Input() showLanguageSelector?: boolean;

  flagClass(locale: string) {
    return locale && locale.length !== 2 ? 'zef-lang-other' : `zef-lang-${locale}`;
  }
}
